export const BLACKLIST_TYPE = {
	GENRE: 1,
	LABEL: 2,
	ARTIST: 3,
	ISRC: 4,
	VARIIS_ID: 5,
};
